import { DefaultService } from '@/services/DefaultService';


export default class PacoteKitService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllPacotesByProduto(idproduto, limit, ...params) {
        return this._http.get(`${this._env}/sales/package/product/${idproduto}.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findAll(situacao, column, limit = 50, page = 0, order = 'asc', ...params) {
        return this._http.get(`${this._env}/sales/package/findall.json?situacao=${situacao}&page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findAllPacotesByIdProduto(idproduto, column, limit = 50, page = 0, order = 'asc', situacao, ...params) {
        return this._http.get(`${this._env}/sales/packageproduct/getall/product/${idproduto}.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findAllComboPacote(idproduto, limit = 100, ...params){
        return this._http.get(`${this._env}/sales/package/product/findallcombopacote/${idproduto}.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findAllComboTabPreco( limit = 100, ...params){
        return this._http.get(`${this._env}/vendas/tabpreco/findallcombo.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findAllComboUnidadeMedida( limit = 100, id, idsituacao, ...params){
        return this._http.get(`${this._env}/vendas/unitmeasure/findallcombowithproduct.json?limit=${limit}&id=${id}&idsituacao=${idsituacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    savePacoteProduto(pacoteProduto){
            return this._http.post(`${this._env}/sales/packageproduct/product`, pacoteProduto, this._headers).then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
            });
    }
    updateSituacaoPacote(pacote){
        return this._http.post(`${this._env}/sales/package/updatesituacao`, pacote, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    updateSituacao(pacoteProduto){
        return this._http.post(`${this._env}/sales/packageproduct/updatesituacao`, pacoteProduto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    save(pacote){
        return this._http.post(`${this._env}/sales/package`, pacote, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            return err.body;
        });
    }
    findIdAssPacoteProduto(idpacoteproduto) {
        return this._http.get(`${this._env}/sales/packageproduct/${idpacoteproduto}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    find(id) {
        return this._http.get(`${this._env}/sales/package/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}